import { Form, Formik } from 'formik'
import React, { useContext, useMemo, useRef } from 'react'
import { SearchContext } from '../../../../contexts/SearchContext'
import ReactSelect from '../../../FormComponents/ReactSelect'
import Modal from '../../../Modal/Modal'
import * as Yup from 'yup'
import axiosService from '../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../FormComponents/Toasts'
import { useParams, useNavigate } from 'react-router-dom'

export default function CampaignModal({ authentication, modalOpen, setModalOpen }) {
  const {campaign_id, campaign_status_id } = useParams()
  const { campaigns } = useContext(SearchContext)
  const navigate = useNavigate()
  const navigateRef = useRef(navigate)
  const campaignOptions = useMemo(() => campaigns.map(campaign => ({ label: campaign.name, value: campaign.id })), [campaigns, campaigns.length])

  const addInfluencerToCampaign = ({ campaign_id, campaign_status_id }) => {
    axiosService.post(`/api/project_manager/authentications/${authentication.id}/add_to_campaign`, { campaign_id, campaign_status_id })
    .then((response) => {
      toastSuccess('Added to campaign')
      if (response.campaign_id_for_redirect) {
        navigateRef.current(`/project_manager/campaigns/${response.campaign_id_for_redirect}/influencers`)
      } else {
        setModalOpen(false)
      }
    })
    .catch((error) => toastError(error.data.error))
  }

  const selectedCampaign = campaigns.find(campaign => +campaign.id === +campaign_id)

  return (
    <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
      <Modal.Header>
        <span className="font-bold text-lg dark:text-white">Add to campaign</span>
      </Modal.Header>
      <Modal.Body>
        <div className="w-[440px]">
          <Formik
            validationSchema={
              Yup.object().shape({ campaign_id: Yup.number().nullable().required('This field is required.') })
            }
            initialValues={{
              campaign_id: campaign_id || null,
              campaign_status_id: campaign_status_id || null
            }}
            onSubmit={addInfluencerToCampaign}
          >
            {({ handleBlur, handleChange, values, errors, touched, setFieldValue }) => (
              <Form>
                <div className="w-full">
                  {
                    campaign_id && campaign_status_id ?
                      <div>
                        <p className="dark:text-white">Add <strong>{authentication.username}</strong> to <strong>{selectedCampaign?.name}</strong>?</p>
                      </div>
                      :
                      <ReactSelect error={touched.campaign_id && errors.campaign_id} label="Campaign" noLabelPadding name="campaign_id"
                        placeholder="Select a campaign"
                        onChange={campaign_id => setFieldValue('campaign_id', campaign_id.value, true)}
                        onBlur={handleBlur} value={values.campaign_id} options={campaignOptions} />
                  }

                  <div className="flex justify-between mt-5">
                    <Modal.DissmissButton
                      className="rb-btn-cancel px-4 py-2 text-sm font-semibold rounded-lg"
                    >
                      Cancel
                    </Modal.DissmissButton>
                    <button
                      type="submit"
                      className="ml-auto px-4 py-2 text-sm font-semibold text-white bg-rb-green rounded-lg dark:text-rb-dark-mode"
                    >
                      Add to campaign
                    </button>
                  </div>

                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  )
}